"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var Types = require("types");
var deleteActions = require("@caddigital/sok-reducers/lib/actions/project/delete");
var projects_1 = require("@caddigital/sok-reducers/lib/actions/projects");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./styles.scss");
var mapStateToProps = function (state) {
    return {
        delete: state.project.delete
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    toggleDeleteModal: function (project) {
        if (project !== undefined) {
            dispatch((0, projects_1.toggleSelection)(project));
        }
        dispatch(deleteActions.toggleDeleteModal());
    },
    deleteProject: function (project) {
        return dispatch(deleteActions.deleteProjectRequest(project));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { className: 'delete-project-modal', isOpen: props.delete.isOpen },
        React.createElement(sok_ui_1.Header, { onClose: function () {
                return props.delete.status !== 'DELETING' &&
                    props.toggleDeleteModal(props.delete.project);
            } }, (0, translation_1.getLocalization)('admin/projectsTab/buttons/deleteproject/confirmation')),
        React.createElement(sok_ui_1.Container, null, props.delete.status === 'INITIAL' ? ([
            React.createElement(sok_ui_1.Row, { key: 'row-1' },
                React.createElement(React.Fragment, null,
                    React.createElement(ConfirmDialog_1.Exclamation, { className: 'delete-project-exclamation-icon' }),
                    React.createElement("div", null,
                        React.createElement("div", { className: 'title please-confirm-text' },
                            React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('admin/projectsTab/buttons/deleteproject/ConfirmationHeader'))),
                        React.createElement("div", { className: 'confirmation-text' },
                            React.createElement("p", null, (0, translation_1.getLocalization)('admin/projectsTab/buttons/deleteproject/ConfirmationText'))))))
        ]) : (React.createElement("div", { className: 'spinner', key: 'spinner' },
            React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.delete.status === 'DELETING', success: props.delete.status === 'DELETED' }),
            props.delete.status === 'DELETING' && (React.createElement("p", null, (0, translation_1.getLocalization)('components/projectDelete/deleting'))),
            props.delete.status === 'DELETED' && (React.createElement("p", null, (0, translation_1.getLocalization)('components/projectDelete/success'))),
            props.delete.status === 'FAILED' && (React.createElement("p", null, (0, translation_1.getLocalization)('components/projectDelete/failed')))))),
        React.createElement(sok_ui_1.Footer, null,
            props.delete.status === 'INITIAL' && (React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('buttons/delete'), onClick: function () {
                    return props.delete.project && props.deleteProject(props.delete.project);
                }, disabled: props.delete.project === undefined })),
            React.createElement(sok_ui_1.Button, { color: props.delete.status === 'DELETED' ? 'blue' : 'gray', text: (0, translation_1.getLocalization)('buttons/close'), disabled: props.delete.status === 'DELETING', onClick: function () { return props.toggleDeleteModal(props.delete.project); } }))));
});
